<div class="form--full-width" [ngClass]="getLevelClass()">
  <basic-label></basic-label>
  <div class="row">
    <basic-text-input
      [propertyName]="questionItem.prop + '.idNumber'"
      [disableConditionally]="noDriversLicense.inputText"
      [isDriversLicense]="true"
      #licenseNumber
      (focusin)="showLicenseNumber()"
      (focusout)="obfuscateLicenseNumber()"
    ></basic-text-input>
  </div>
  <div class="row">
    <div>
      <label *ngIf="isServer" class="entry-field__label">State or Country of Issue</label>
      <select-basic
        [property]="questionItem.prop + '.idState'"
        [placeholder]="'Select State...'"
        [showTitle]="false"
        [disableConditionally]="noDriversLicense.inputText"
        [isDriversLicense]="true"
        #licenseState
      ></select-basic>
    </div>
    <div>
      <label *ngIf="isServer" class="entry-field__label">Expiry date (mm/dd/yyyy)</label>
      <basic-text-input
        [propertyName]="questionItem.prop + '.idExpires'"
        [placeholder]="'Expiry date (mm/dd/yyyy)'"
        [parserType]="'Date'"
        [formatterType]="'date_mmddyyyy'"
        (change)="trigger()"
        [disableConditionally]="noDriversLicense.inputText"
        [isDriversLicense]="true"
        [inputMask]="mask"
        #licenseExpirationDate
      ></basic-text-input>
    </div>
  </div>
  <div class="row">
    <basic-checkbox
      id="hasNoDriversLicense"
      (change)="trigger()"
      labelText="{{ is2020CoverpathOrMMD ? 'No Driver\'s License' : 'I don\'t have a Driver\'s License' }}"
      [propertyName]="questionItem.prop + '.hasNoDriversLicense'"
      [skipModelUpdate]="true"
      #noDriversLicense
    ></basic-checkbox>
  </div>
</div>
